import { AuditMatch } from '@mi-front/core';
import { Box } from '@mui/material';
import { BcrMatchStatus } from './BcrMatchStatus';
import { ConfirmedBySchedule } from './ConfirmedBySchedule';
import { ManualMatchIndicator } from './ManualMatchIndicator';

export function MatchStatuses(p: { match: AuditMatch }) {
  return (
    <Box display="flex" gap={1} alignItems="center">
      {p.match.source === 'MANUAL' && <ManualMatchIndicator />}
      {p.match.matchedSchedule && (
        <ConfirmedBySchedule match={p.match} schedule={p.match.matchedSchedule} />
      )}
      <BcrMatchStatus match={p.match} />
    </Box>
  );
}
